import { useState } from 'react';
import axios from 'axios';
import { API_STATUS } from '../utils/constants';
import { toastWarn } from '../utils/toasts';

export function useCreateRecord() {
   const [createResponseData, setCreateResponseData] = useState(null);
   const [createStatus, setCreateStatus] = useState(API_STATUS.IN_PROGRESS);

   const createApi = async (url) => {
      try {
         const response = await axios.get(url, {
            headers: {
               'content-type': 'application/json',
            },
         });

         if (response.status !== 200) {
            toastWarn(response.data.message);
            setCreateResponseData({});
            setCreateStatus(API_STATUS.FAILED);
            return null;
         } else {
            setCreateResponseData(response?.data);
            setCreateStatus(API_STATUS.COMPLETED);
            return response?.data;
         }
      } catch (error) {
         console.warn('Error in Creating records', error);
         setCreateResponseData({});
         setCreateStatus(API_STATUS.FAILED);
         toastWarn(error.message);
         return null;
      }
   };

   return { createResponseData, createStatus, createApi };
}
